import { render, staticRenderFns } from "./PointNetridecash.vue?vue&type=template&id=d8f09736"
import script from "./PointNetridecash.vue?vue&type=script&lang=js"
export * from "./PointNetridecash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports